import { render, staticRenderFns } from "./data-access.vue?vue&type=template&id=4c96a0b0&scoped=true&"
import script from "./data-access.ts?vue&type=script&lang=ts&"
export * from "./data-access.ts?vue&type=script&lang=ts&"
import style0 from "./data-access.scss?vue&type=style&index=0&id=4c96a0b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96a0b0",
  null
  
)

export default component.exports